import { type SVGProps } from 'react';

export function CaretUp(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true" fill="currentcolor" focusable="false" {...props}>
      <path d="M7.557 10.854a.5.5 0 00.707 0l4.59-4.59a.5.5 0 00-.708-.707l-4.239 4.24-4.244-4.245a.498.498 0 10-.704.704l4.598 4.598z"></path>
    </svg>
  );
}
